import React from 'react';
import { InvoiceTemplateProps } from './types';
import InvoiceTitle from './primitives/Title';
import PatientInfo from './primitives/PatientInfo';
import InvoiceDetails from './primitives/InvoiceDetails';
import ItemsTable from './primitives/ItemsTable';
import Totals from './primitives/Totals';
import Footer from './primitives/Footer';

export default function Template2_A4WithoutHeader({ invoice, hospital }: InvoiceTemplateProps) {
  return (
    <div 
      className="invoice-root bg-white p-8 max-w-[210mm] mx-auto" 
      style={{ 
        minHeight: '297mm',
        fontFamily: 'Inter, "Noto Sans Bengali", Arial, sans-serif',
      }}
    >
      <div className="text-center mb-4">
        <p className="text-sm text-gray-600">{hospital.name}</p>
      </div>

      <InvoiceTitle />

      <div className="grid grid-cols-2 gap-8 mb-3">
        <PatientInfo invoice={invoice} layout="column" />
        <InvoiceDetails invoice={invoice} />
      </div>
      
      <ItemsTable items={invoice.items} variant="standard" headerColor="bg-blue-600" />
      
      <Totals invoice={invoice} layout="standard" showPaymentInfo={true} />
      
      <Footer variant="minimal" notes={invoice.notes} />
    </div>
  );
}
